import { UpdateDomainsMutation, UpdateDomainsMutationVariables } from 'gql/graphql'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DomainTableSchema } from '../../schema'
import { toDTO } from './api/mapper'
import { UPDATE_DOMAINS } from './api/mutation'

type UseSaveDomainProducts = {
  loading: boolean
  update: (data: DomainTableSchema) => void
}

export const useSaveDomainProducts = (): UseSaveDomainProducts => {
  const { t } = useTranslation('features/domain')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending, mutateAsync } = useMutation<
    { input: UpdateDomainsMutationVariables['input'] },
    UpdateDomainsMutation
  >({
    mutation: UPDATE_DOMAINS,
    onCompleted: async (data: UpdateDomainsMutation) => {
      const errors = data.updateDomains?.errors

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('list.save.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('list.save.success'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getDomainsForTable'],
  })

  const update = (data: DomainTableSchema): void => {
    const input = toDTO(data)

    if (input.domainsAttributes?.length === 0) {
      return
    }

    void mutateAsync({
      input,
    })
  }

  return {
    loading: isPending,
    update,
  }
}
